import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Award } from 'lucide-react';

const WebsiteFooter = ({ onSecurityFAQClick }) => {
  return (
    <footer className="mt-16 py-8 border-t border-gray-200 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <div className="text-center space-y-4">
          {/* Support & Social Links */}
          <div className="flex flex-wrap justify-center items-center gap-4 text-sm">
            <a
              href="mailto:support@coincommons.io"
              className="text-blue-600 hover:text-blue-700 font-medium transition flex items-center gap-1"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              support@coincommons.io
            </a>
            <span className="text-gray-300">|</span>
            <a
              href="https://twitter.com/coincommons"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-700 font-medium transition flex items-center gap-1"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
              @coincommons
            </a>
            <span className="text-gray-300">|</span>
            <Link
              to="/popular-coins"
              className="text-blue-600 hover:text-blue-700 font-medium transition flex items-center gap-1"
            >
              <Award className="w-4 h-4" />
              Popular Coins
            </Link>
            <span className="text-gray-300">|</span>
            <button
              onClick={onSecurityFAQClick}
              className="text-blue-600 hover:text-blue-700 font-medium transition flex items-center gap-1"
            >
              <Shield className="w-4 h-4" />
              Security FAQ
            </button>
            {/* <span className="text-gray-300">|</span>
            <Link
              to="/terms"
              className="text-blue-600 hover:text-blue-700 font-medium transition flex items-center gap-1"
            >
              <FileText className="w-4 h-4" />
              Terms of Service
            </Link> */}
          </div>

          {/* Description */}
          <div className="text-xs text-gray-600 max-w-2xl mx-auto">
            Community-Powered Crypto Safety
          </div>

          {/* Copyright & Legal */}
          <div className="text-xs text-gray-500 space-y-1">
            <div>© 2025 CoinCommons. All rights reserved.</div>
            <div className="text-gray-400">
              By using CoinCommons, you agree to our <Link to="/terms" className="text-blue-500 hover:underline">Terms of Service</Link> and <Link to="/privacy" className="text-blue-500 hover:underline">Privacy Policy</Link>.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default WebsiteFooter;
